import CommonFunctions from './common-functions';
import SiriWave from 'siriwave';
export default class ProductSearch {
    constructor() {
        this.searchInputField = '[data-product-search-input]';
        this.dropDownContainer = '[data-product-search-dropdown]';
        this.dealType = '[data-product-search-deal-type]';
        this.speechRecognition = '[data-product-search-dictation]';
        this.searchLoading = '[data-product-search-loading]';
        this.voiceIsEnabled = window.hasOwnProperty('webkitSpeechRecognition');
        let commonfunctions = new CommonFunctions();
        this.addProductSearchKeyPressEventListener();
        this.addDictationLinkClickListener();
        this.closeSearchResultsDropDown();
        this.addProductSearchClickEventListener();
        this.convertSelectIntoCustomContainer();
        this.searchHeaderToggle();
        this.placeholderAnimate();
        this.enableSpeedDictation();
        document.addEventListener('click', commonfunctions.closeAllSelect);
    }

    addProductSearchKeyPressEventListener() {
        let timeout;
        const humanize = 200;
        let commonfunctions = new CommonFunctions();
        document.querySelector(this.searchInputField).addEventListener('keyup', (event) => {
            const value = event.srcElement.value;
            const dropDownContainer = document.querySelector(this.dropDownContainer);
            if (!value) {
                dropDownContainer.classList.add('hide');
                dropDownContainer.classList.remove('show');
                commonfunctions.hideSearchLoading();
                return;
            }
            commonfunctions.showSearchLoading();

            if (timeout) {
                clearTimeout(timeout);
            }
            const dealType = document.querySelector('[data-product-search-selected-deal-type]').dataset.productSearchSelectedDealType;
            timeout = setTimeout(function() {
                commonfunctions.populateNullOrLoadingText(dropDownContainer, true);
                commonfunctions.makeRequest(dealType, value, dropDownContainer);
            }, humanize);
        });
    }

    addDictationLinkClickListener() {
        const SW9 = new SiriWave({
            container: document.querySelector('#dictation-display-inner'),
            width: 450,
            height: 330,
            speed: 0.1,
            amplitude: 5,
            autostart: false,
            style: 'ios9',
            cover: true,
            curveDefinition: [
                {
                    color: '255, 255, 255',
                    supportLine: true
                },
                {
                    color: '0, 105, 180'
                },
                {
                    color: '222, 37, 117'
                },
                {
                    color: '241, 131, 63'
                },
            ]
        });
        document.querySelector(this.speechRecognition).addEventListener('click', () => {
            if (window.hasOwnProperty('webkitSpeechRecognition')) {
                const recognition = new webkitSpeechRecognition();
                recognition.continuous = false;
                recognition.interimResults = false;

                recognition.lang = 'en-GB';

                recognition.start();

                recognition.onstart = function() {
                    SW9.start();
                    document.body.classList.add('dictation-active');
                };

                recognition.onend = function() {
                    SW9.stop();
                    document.body.classList.remove('dictation-active');
                };

                let searchInputField = document.querySelector(this.searchInputField);
                let dropDownContainer = document.querySelector(this.dropDownContainer);
                const dealType = document.querySelector('[data-product-search-selected-deal-type]').dataset.productSearchSelectedDealType;
                recognition.onresult = function(e) {
                    const searchQuery = e.results[0][0].transcript;
                    searchInputField.value = searchQuery;
                    let commonfunctions = new CommonFunctions();
                    commonfunctions.showSearchLoading();
                    commonfunctions.makeRequest(dealType, searchQuery, dropDownContainer);
                };

                recognition.onerror = function() {
                    recognition.stop();
                };

                recognition.onspeechend = function() {
                    recognition.stop();
                };

            }
        });
    }

    closeSearchResultsDropDown() {
        let dropdownSelector = document.querySelector(this.dropDownContainer);
        let searchInputField = document.querySelector(this.searchInputField);
        document.addEventListener('click', function(event) {
            let isClickInsideDropdown = dropdownSelector.contains(event.target);
            let isClickInsideSearchInput = searchInputField.contains(event.target);
            if (isClickInsideDropdown || (isClickInsideSearchInput && searchInputField.value)) {
                dropdownSelector.classList.add('show');
                dropdownSelector.classList.remove('hide');
            } else {
                dropdownSelector.classList.remove('show');
                dropdownSelector.classList.add('hide');
            }
        });
    }

    addProductSearchClickEventListener() {
        let searchInputField = document.querySelector(this.searchInputField);
        let dropdownSelector = document.querySelector(this.dropDownContainer);
        searchInputField.addEventListener('click', (event) => {
            const value = event.srcElement.value;
            if (value) {
                dropdownSelector.classList.add('show');
                dropdownSelector.classList.remove('hide');
            }
        });
    }

    convertSelectIntoCustomContainer() {
        let commonfunctions = new CommonFunctions();
        let dealTypeSelectElementContainer = document.querySelector('[data-product-search-deal-type-dropdown]');
        let selElmnt = document.querySelector('[data-product-search-deal-type-select]');
        let dropdownSelector = document.querySelector(this.dropDownContainer);
        const ll = selElmnt.length;
        let selectedElement = document.createElement('div');
        selectedElement.setAttribute('class', 'select-selected search-box-options custom-search-box-options');
        selectedElement.setAttribute('data-product-search-selected-deal-type', selElmnt.options[selElmnt.selectedIndex].value);
        selectedElement.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        dealTypeSelectElementContainer.appendChild(selectedElement);

        let dealTypeSelectListItems = document.createElement('div');
        dealTypeSelectListItems.setAttribute('class', 'select-items select-hide');
        for (let j = 0; j < ll; j++) {
            let dealTypeSelectListItem = document.createElement('div');
            dealTypeSelectListItem.innerHTML = selElmnt.options[j].innerHTML;
            dealTypeSelectListItem.addEventListener('click', function() {
                let s = this.parentNode.parentNode.getElementsByTagName('select')[0];
                const sl = s.length;
                let h = this.parentNode.previousSibling;
                for (let i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        h.setAttribute('data-product-search-selected-deal-type', s.options[i].value);
                        let y = this.parentNode.getElementsByClassName('same-as-selected');
                        const yl = y.length;
                        for (let k = 0; k < yl; k++) {
                            y[k].removeAttribute('class');
                        }
                        this.setAttribute('class', 'same-as-selected');
                        break;
                    }
                }
                h.click();
            });
            dealTypeSelectListItems.appendChild(dealTypeSelectListItem);
        }
        dealTypeSelectElementContainer.appendChild(dealTypeSelectListItems);
        selectedElement.addEventListener('click', function(e) {
            dropdownSelector.classList.remove('show');
            dropdownSelector.classList.add('hide');
            e.stopPropagation();
            commonfunctions.closeAllSelect(this);
            this.nextSibling.classList.toggle('select-hide');
            this.classList.toggle('select-arrow-active');
        });

        let searchInputField = document.querySelector(this.searchInputField);
        dealTypeSelectListItems.querySelectorAll('div').forEach((selectedItem) => {
            if (!selectedItem.classList.contains('same-as-selected')) {
                selectedItem.addEventListener('click', function() {
                    if (searchInputField.value) {
                        const dealType = document.querySelector('[data-product-search-selected-deal-type]').dataset.productSearchSelectedDealType;
                        commonfunctions.showSearchLoading();
                        commonfunctions.populateNullOrLoadingText(dropdownSelector, true);
                        commonfunctions.makeRequest(dealType, searchInputField.value, dropdownSelector);
                    }
                });
            }
        });
    }

    searchHeaderToggle() {
        document.querySelectorAll("a[data-target='#search']").forEach((selectedItem) => {
            selectedItem.addEventListener('click', function() {
                document.querySelector('body').classList.toggle('header-search-active');
            });
        });
    }

    placeholderAnimate() {
        window.addEventListener('load', () => {
            let i = 0;
            let placeholder = '';
            const placeholderTxt = "Hello ... is it me you're looking for... ?";
            const speed = 120;

            function type() {
                placeholder += placeholderTxt.charAt(i);
                document.getElementById('searchText').setAttribute('placeholder', placeholder);
                i++;
                setTimeout(type, speed);
            }
            type();
        });
    }

    enableSpeedDictation() {
        if (this.voiceIsEnabled) {
            document.querySelector(this.speechRecognition).classList.toggle('hide');
        }
    }
}
